module.exports = __webpack_public_path__ + "static/media/D_Q.f2d931e0.png";